import { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

type NavigationMode = 'debutante' | 'etablie';

interface NavigationContextType {
  mode: NavigationMode;
  setMode: (mode: NavigationMode) => Promise<void>;
  isLoading: boolean;
}

const NavigationContext = createContext<NavigationContextType | null>(null);

export const NavigationProvider = ({ children, userId }: { children: React.ReactNode; userId: string }) => {
  const [mode, setModeState] = useState<NavigationMode>('debutante');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from('profils')
        .select('*')
        .eq('user_id', userId)
        .single();
      if (data && (data as any).mode_navigation) {
        setModeState((data as any).mode_navigation as NavigationMode);
      }
      setIsLoading(false);
    };
    load();
  }, [userId]);

  const setMode = async (newMode: NavigationMode) => {
    setModeState(newMode);
    await supabase
      .from('profils')
      .upsert({ user_id: userId, mode_navigation: newMode } as any, { onConflict: 'user_id' });
  };

  return (
    <NavigationContext.Provider value={{ mode, setMode, isLoading }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const ctx = useContext(NavigationContext);
  if (!ctx) throw new Error('useNavigation must be used within NavigationProvider');
  return ctx;
};
